/**
 * Represents the mode of color transformation
 */
export const enum ColorTransformDirection {
    /**
     * Transform from light to dark
     */
    LightToDark = 0,

    /**
     * Transform from dark to light
     */
    DarkToLight = 1,
}
